import _ from "./_ListCache.js";
import e from "./_Map.js";
import r from "./_MapCache.js";
var h = 200;
function m(i, s) {
  var t = this.__data__;
  if (t instanceof _) {
    var a = t.__data__;
    if (!e || a.length < h - 1)
      return a.push([i, s]), this.size = ++t.size, this;
    t = this.__data__ = new r(a);
  }
  return t.set(i, s), this.size = t.size, this;
}
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stackSet.js
// module id = 1553
// module chunks = 67